export const roleAfil = {
  label: "AFILIADO",
  value: "3",
};

export const rolePrest = {
  label: "PRESTADOR",
  value: "2",
};

export const roleProm = {
  label: "PROMOTOR",
  value: "4",
};
